module.exports = __webpack_public_path__ + "img/23.0772b650.svg";